<script setup>
// Feedbackify drains `window.fby` once it loads, so a click before then still opens the form.
const showFeedback = () => nextTick(() => (window.fby = window.fby || []).push(['showForm', '15544']))

onMounted(() => {
  onNuxtReady(() =>
    injectClientSideScripts([{ id: 'footer-feedbackify', src: '//cdn.feedbackify.com/f.js', defer: true }]),
  )
})
</script>

<template>
  <div class="footer__feedback">
    <button class="footer__feedback-button" @click.prevent="showFeedback">
      <span class="footer__feedback-text">{{ $t('feedback.text') }}</span>
    </button>
  </div>
</template>

<style scoped lang="postcss">
.footer__feedback {
  display: flex;

  .footer__feedback-button {
    border: none;
    outline: inherit;
    background-color: transparent;
    cursor: pointer;
  }

  .footer__feedback-text {
    font-family: var(--text-secondary);
    font-size: var(--text-small);
    line-height: 1.5; /* leading-default */
    letter-spacing: 0.05em; /* tracking-default */
    text-decoration: underline;
    text-transform: uppercase;
  }

  .footer__feedback-text:hover {
    color: var(--text-link-hover);
  }
}
</style>
